const groups = {
  0: { // For me to change things even admins shouldnt be able to
    name: 'superuser',
    parents: []
  },
  1: {
    name: 'admin',
    parents: [0]
  },
  2: {
    name: 'user',
    parents: [1]
  },
  3: {
    name: 'production manager',
    parents: [1]
  },
  4: {
    name: 'production worker',
    parents: [3]
  }
}

const userHasAccess = (requiredGroupID, userGroups) => {
  var completeAccessList = walk(requiredGroupID, [])
  // console.log(completeAccessList)
  for (var userGroup of userGroups) {
    if (completeAccessList.includes(userGroup)) {
      return true
    }
  }
  return false
}

const walk = (nodeID, accumulator) => {
  accumulator.push(nodeID)
  var node = groups[nodeID]
  if (!node) {
    return accumulator
  }
  if (node.parents.length > 0) {
    node.parents.forEach(childID => {
      walk(childID, accumulator)
    })
  }
  return accumulator
}

// npx babel-node ./test.js

export default {
  groups,
  userHasAccess
}
